// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__1yVXK","avatar":"style_avatar__19EFS","menuIcon":"style_menuIcon__w30cJ"};